import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route
} from 'react-router-dom'

import { PrivateRoute } from '../types/PrivateRoute'

import DailyMonitoringRoutes from './DailyMonitoringRoutes'
import EventsRoutes from './EventsRoutes'
import OrdersRoutes from './OrdersRoutes'
import CartChangeRoutes from './CartChangeRoutes'
import ProductRoutes from './ProductRoutes'
import FactoryRoutes from './FactoryRoutes'
import Home from '../pages/Index'

export const PrivateRoutes = ({ component: Component, auth }: PrivateRoute) => (
  <Route exact render={props => auth.accessToken && auth.idToken
    ? <Component {...props} />
    : <Redirect to={{ pathname: '/' }} />
  }
  />
)

export default function Routes (): JSX.Element {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/monitoramento-diario/*" component={DailyMonitoringRoutes} />
        <Route path="/produtos" component={ProductRoutes} />
        <Route path="/industrias" component={FactoryRoutes} />
        <Route path="/analise-de-eventos/*" component={EventsRoutes} />
        <Route path="/pedidos/*" component={OrdersRoutes} />
        <Route path="/mudanca-de-cesta/*" component={CartChangeRoutes} />
      </Switch>
    </Router>
  )
}
